import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import { GmailFolderEntity } from "@cohesive/api-entities";
import { useQuery } from "@tanstack/react-query";

export function useGmailFoldersList(connection: IntegrationConnection) {
  return useQuery({
    queryKey: ["gmail-folders-list", connection.id],
    queryFn: () => {
      return orgAPI.toolbox.execute<GmailFolderEntity[]>({
        integration_connection_id: connection.id,
        action_name: "gmail-folders-list",
        action_input: {},
      });
    },
  });
}
